import template from './statistics.html'
import controller from './statistics.controller'
import service from './statistics.service'
import './statistics.scss'

let module = angular.module('statistics', [
	'ionic'
])
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.statistics', {
			url: '/statistics',
			views: {
				'tab-more': {
					template: template,
					controller: controller,
					controllerAs: 'statistics'
				}
			},
		})
})
.service('Statistics', service)
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/statistics/statistics.js